import classNames from "classnames";
import Tooltip from "../../../../Components/common/Tooltip/Tooltip";

const Field = ({
  width,
  name,
  value,
  onChange,
  onBlur,
  tooltipText,
  label,
  className,
  parentClassName,
  placeholder,
  tooltipWidth,
  type = "text",
  showFlowGrow = false,
  disabled = false,
  autoComplete,
}) => {
  return (
    <div className={parentClassName}>
      <p
        className={classNames("settings__label", {
          "settings__label--disabled": disabled,
        })}>
        {label}
        {tooltipText && (
          <Tooltip tooltipWidth={tooltipWidth} text={tooltipText} showFlowGrow={showFlowGrow} />
        )}
      </p>
      <input
        className={`settings__field ${className}`}
        name={name}
        value={value}
        onChange={onChange}
        style={{ width }}
        type={type}
        placeholder={placeholder}
        disabled={disabled}
        onBlur={onBlur}
        autoComplete={autoComplete}
      />
    </div>
  );
};

export default Field;
